import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { registrationRoutesConfig } from './auto-registration/registration-config';
import { AutoRegistrationComponent } from './auto-registration/auto-registration.component';
import { SignUpComponent } from './auto-registration/sign-up/sign-up.component';
import { RegistrationStepsComponent } from './auto-registration/registration-steps/registration-steps.component';
import { SmartSuggestionsComponent } from './auto-registration/smart-suggestions/smart-suggestions.component';

const autoRegistrationRoutes: Routes = [
  {
    path: '',
    component: AutoRegistrationComponent,
    children: [
      { path: '', redirectTo: registrationRoutesConfig.SIGNUP, pathMatch: 'full' },
      {
        path: registrationRoutesConfig.SIGNUP,
        component: SignUpComponent,
      },
      {
        path: registrationRoutesConfig.RESET_PASSWORD,
        component: SignUpComponent,
      },
      {
        path: registrationRoutesConfig.CHOOSE_BUSINESS,
        component: RegistrationStepsComponent,
      },
      {
        path: registrationRoutesConfig.VERIFY,
        component: SignUpComponent,
      },
      {
        path: registrationRoutesConfig.SMART_SUGGESTIONS,
        component: SmartSuggestionsComponent,
      },
    ],
  },
];

const routes: Routes = [
  ...autoRegistrationRoutes,
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
